import React, { useState, useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

const APP_VERSION =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";
const APP_VERSION_STORAGE_KEY = "app:version";
const APP_UPDATE_NOTICE_KEY = "app:update-notice";

const clearRuntimeCaches = async () => {
  if ("caches" in window) {
    const cacheKeys = await window.caches.keys();
    await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
  }

  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map((registration) => registration.unregister())
    );
  }
};

const App = () => {
  const [locale, setLocale] = useState();
  const [updateModalOpen, setUpdateModalOpen] = useState(false);

  const theme = createTheme(
    {
      scrollbarStyles: {
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
          backgroundColor: "#e8e8e8",
        },
      },
      palette: {
        primary: { main: "#0035a2" },
        background: { default: "#0035a2" },
      },
    },
    locale
  );

  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng") || "pt-BR";
    const browserLocale =
      i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

    if (browserLocale === "ptBR") {
      setLocale(ptBR);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    const handleVersionUpdate = async () => {
      const storedVersion = localStorage.getItem(APP_VERSION_STORAGE_KEY);
      const noticeVersion = sessionStorage.getItem(APP_UPDATE_NOTICE_KEY);

      if (!storedVersion) {
        localStorage.setItem(APP_VERSION_STORAGE_KEY, APP_VERSION);
      } else if (storedVersion !== APP_VERSION) {
        try {
          await clearRuntimeCaches();
        } catch (error) {
          console.warn("Não foi possível limpar o cache local:", error);
        }
        localStorage.setItem(APP_VERSION_STORAGE_KEY, APP_VERSION);
        sessionStorage.setItem(APP_UPDATE_NOTICE_KEY, APP_VERSION);
        window.location.reload();
        return;
      }

      if (noticeVersion === APP_VERSION && isMounted) {
        setUpdateModalOpen(true);
      }
    };

    handleVersionUpdate();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleCloseUpdateModal = () => {
    sessionStorage.removeItem(APP_UPDATE_NOTICE_KEY);
    setUpdateModalOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={updateModalOpen}
        onClose={handleCloseUpdateModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Atualização aplicada</DialogTitle>
        <DialogContent dividers>
          <Typography>
            O sistema foi atualizado para a versão {APP_VERSION}. O cache local
            foi limpo e a página foi recarregada.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseUpdateModal}
            color="primary"
            variant="contained"
          >
            Continuar
          </Button>
        </DialogActions>
      </Dialog>
      <Routes />
    </ThemeProvider>
  );
};

export default App;
